import { render, staticRenderFns } from "./TestimonialsCard.vue?vue&type=template&id=9928477c&scoped=true&"
import script from "./TestimonialsCard.vue?vue&type=script&lang=js&"
export * from "./TestimonialsCard.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialsCard.vue?vue&type=style&index=0&id=9928477c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9928477c",
  null
  
)

export default component.exports